export class DropDown{
    Options = [];
    selectedOption = {};

    pageNo = 0;
    loading = false;
    term : any;
}